skrilla.controller('adminsCtrl', function ($scope, searchService, envService, cacheService, modalService) {

    $scope.passwordType = "password";
    $scope.query = {
        statuses: {
            LOCKED: false,
            ACTIVE: true
        }
    };

    $scope.showPassword = function(){
        $scope.passwordType = $scope.passwordType === "password" ? "text" : "password";
    }

    if(envService.get() != 'production'){
        $scope.newAdmin = {zenDeskId: 0};
    }

    function search() {
        searchService.get('admins').then(function (response) {
            $scope.admins = response.data;
        });
    }
    search();

    function getRoles(){
        searchService.get("roles").then(function(response){
            $scope.roles = response.data;

            $scope.query.roles = {}
            $scope.roles.forEach(it => {
                if (it.type === "Admin") {
                    $scope.query.roles[it.name] = true
                }
            })

        });
    }
    getRoles();

    $scope.editAdmin = function(admin){
        cacheService.registerObject("admin", admin)
        modalService.openModal("/views/adminDetails/adminDetails.html", true, 'lg', false, false)
    }

    $scope.createRole = function(){
        cacheService.registerObject("role", {});
        modalService.openModal('/views/admins/permissionsModal.html', true, 'lg', false, false,
          () => getRoles()
        )
    }

    $scope.editRole = function(role){
        if (role.type == "Admin") {
            cacheService.registerObject("role", role);
            modalService.openModal('/views/admins/permissionsModal.html', true, 'lg', false, false,
                () => getRoles()
            )
        } else {
            console.log("Can't edit non admin roles")
        }
    }
    $scope.isVisible = function(admin){
        return $scope.query.statuses[admin.status] && $scope.query.roles[admin.roleName]
    }

    $scope.createAdmin = function(){
        $scope.newAdmin.password = $scope.newAdmin.password || "Password12";
        searchService.post('admins', $scope.newAdmin).then(function(response){
            var msg = response.data === false? "Admin created but failed to create Zendesk Account!" : "Admin successfully created";
            swal("Success!", msg, "success");
            search();
            $scope.newAdmin = {};
            if(envService.get() != 'production'){
                $scope.newAdmin = {zenDeskId: 0};
            }
        }, (response) => {
            swal("Error!", response.data.errors[0].message)
        });
    }

});

